import { api } from "../api";
import { EMPTY_GUID, TEMP_GUID, asArray } from '../../utils/fermer-enregistrement-capture.js';
import { resolveEspeceDescription } from '../../utils/fermer-enregistrement-peche-capture.js';

export async function rechercherEnregistrement(email, noEnregistrement) {
    // return api.get(``)
    return null
}

export async function getEnregistrementList(idClient) {
    return api.get(`Enregistrement/FermetureEnregistrement/${idClient}`)
}

export async function getEnregistrement(idEnregistrementEntete) {
  return api.get(`Enregistrement/${idEnregistrementEntete}/Enregistrement`);
}

export async function getContexteFermetureChasse(idEnregistrementEntete) {
  const contexte = await api.get(`Enregistrement/${idEnregistrementEntete}/ContexteFermetureChasse`);
  return {
    idEnregistrementDetailChasse: contexte?.idEnregistrementDetailChasse || contexte?.IdEnregistrementDetailChasse || '',
    idActiviteChasse: contexte?.idActiviteChasse || contexte?.IdActiviteChasse || '',
    secteurs: asArray(contexte?.secteurs || contexte?.Secteurs),
    gibiers: asArray(contexte?.gibiers || contexte?.Gibiers),
  };
}

export async function getContexteFermeturePeche(idEnregistrementEntete) {
  const contexte = await api.get(`Enregistrement/${idEnregistrementEntete}/ContexteFermeturePeche`);
  return {
    idEnregistrementDetailPeche: contexte?.idEnregistrementDetailPeche || contexte?.IdEnregistrementDetailPeche || '',
    idActivitePeche: contexte?.idActivitePeche || contexte?.IdActivitePeche || '',
    pointsEau: asArray(contexte?.pointsEau || contexte?.PointsEau),
  };
}

export async function getActivites() {
  const activites = await api.get('Activite/');
  if (!activites || !Array.isArray(activites)) {
    return [];
  }
  return activites
    .filter(a => a.actif && a.disponibleEnLigne)
    .sort((a, b) => a.description.toUpperCase().localeCompare(b.description.toUpperCase(), 'en'));
}

export async function getCaptures(idEnregistrementEntete) {
  return api.get(`Enregistrement/${idEnregistrementEntete}/Captures`);
}

export async function getPointsEaux(idActivite) {
  const pointsEaux = await api.get(`Activite/${idActivite}/PointEau/`);
  if (!pointsEaux || !Array.isArray(pointsEaux)) {
    return [];
  }
  return pointsEaux
    .filter(pe => pe.idPointEau !== EMPTY_GUID && pe.idPointEau !== TEMP_GUID && pe.disponibleEnLigne && pe.actif)
    .sort((a, b) => a.description.toUpperCase().localeCompare(b.description.toUpperCase(), 'en'));
}

export async function getEspecesPointEau(idPointEau) {
  const pointEauEspeces = asArray(await api.get(`PointEau/${idPointEau}/EspecePointEau`));

  return pointEauEspeces.map(pe => {
    const idEspece = pe.idEspece || pe.IdEspece || pe.id || pe.Id;
    return {
      ...pe,
      idEspece,
      description: resolveEspeceDescription(pe),
    };
  });
}

export async function postFemerEnregistrement(data) {
  return api.post('Enregistrement/FermerEnregistrement', JSON.stringify(data), false);
}
